import SetupStrategy from './setupStrategy';

export default class GarminSetupStrategy extends SetupStrategy {
  constructor(...params) {
    super(...params);
    this.upperName = 'Garmin';
    this.vendor = 'garmin';
  }

  properName() {
    return this.upperName;
  }

  getDeviceLinkingUrl() {
    return this.di.getLinkDeviceUrl('garmin');
  }
}
